import apiHandler from "../core/apiHandler";

const termApi = apiHandler('terms');
export default termApi;
